/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import WalletControllerDtoContentsWalletListResponse from '../model/WalletControllerDtoContentsWalletListResponse';
import WalletControllerDtoDashboardAvailableBalanceRequest from '../model/WalletControllerDtoDashboardAvailableBalanceRequest';
import WalletControllerDtoDashboardAvailableBalanceResponse from '../model/WalletControllerDtoDashboardAvailableBalanceResponse';
import WalletControllerDtoDashboardMiningRequest from '../model/WalletControllerDtoDashboardMiningRequest';
import WalletControllerDtoDashboardMiningResponse from '../model/WalletControllerDtoDashboardMiningResponse';
import WalletControllerDtoDashboardSummaryResponse from '../model/WalletControllerDtoDashboardSummaryResponse';
import WalletControllerDtoDashboardUsageAndDestoryRequest from '../model/WalletControllerDtoDashboardUsageAndDestoryRequest';
import WalletControllerDtoDashboardUsageAndDestoryResponse from '../model/WalletControllerDtoDashboardUsageAndDestoryResponse';
import WalletControllerDtoDepositAddressRequest from '../model/WalletControllerDtoDepositAddressRequest';
import WalletControllerDtoDepositAddressResponse from '../model/WalletControllerDtoDepositAddressResponse';
import WalletControllerDtoDepositRequest from '../model/WalletControllerDtoDepositRequest';
import WalletControllerDtoNotificationSettingInfoResponse from '../model/WalletControllerDtoNotificationSettingInfoResponse';
import WalletControllerDtoNotificationSettingUpdateRequest from '../model/WalletControllerDtoNotificationSettingUpdateRequest';
import WalletControllerDtoTokenSendConditionsInfoResponse from '../model/WalletControllerDtoTokenSendConditionsInfoResponse';
import WalletControllerDtoTokenSendConditionsUpdateRequest from '../model/WalletControllerDtoTokenSendConditionsUpdateRequest';
import WalletControllerDtoXperTgeRequest from '../model/WalletControllerDtoXperTgeRequest';

/**
* Wallet service.
* @module api/WalletApi
* @version 1.0
*/
export default class WalletApi {

    /**
    * Constructs a new WalletApi. 
    * @alias module:api/WalletApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiWalletContentsWalletListPost operation.
     * @callback module:api/WalletApi~apiWalletContentsWalletListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WalletControllerDtoContentsWalletListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/WalletApi~apiWalletContentsWalletListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WalletControllerDtoContentsWalletListResponse}
     */
    apiWalletContentsWalletListPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = WalletControllerDtoContentsWalletListResponse;
      return this.apiClient.callApi(
        '/api/Wallet/ContentsWalletList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletDashboardAvailableBalancePost operation.
     * @callback module:api/WalletApi~apiWalletDashboardAvailableBalancePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WalletControllerDtoDashboardAvailableBalanceResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WalletControllerDtoDashboardAvailableBalanceRequest} [walletControllerDtoDashboardAvailableBalanceRequest] 
     * @param {module:api/WalletApi~apiWalletDashboardAvailableBalancePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WalletControllerDtoDashboardAvailableBalanceResponse}
     */
    apiWalletDashboardAvailableBalancePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['walletControllerDtoDashboardAvailableBalanceRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = WalletControllerDtoDashboardAvailableBalanceResponse;
      return this.apiClient.callApi(
        '/api/Wallet/Dashboard/AvailableBalance', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletDashboardMiningPost operation.
     * @callback module:api/WalletApi~apiWalletDashboardMiningPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WalletControllerDtoDashboardMiningResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WalletControllerDtoDashboardMiningRequest} [walletControllerDtoDashboardMiningRequest] 
     * @param {module:api/WalletApi~apiWalletDashboardMiningPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WalletControllerDtoDashboardMiningResponse}
     */
    apiWalletDashboardMiningPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['walletControllerDtoDashboardMiningRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = WalletControllerDtoDashboardMiningResponse;
      return this.apiClient.callApi(
        '/api/Wallet/Dashboard/Mining', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletDashboardSummaryPost operation.
     * @callback module:api/WalletApi~apiWalletDashboardSummaryPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WalletControllerDtoDashboardSummaryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/WalletApi~apiWalletDashboardSummaryPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WalletControllerDtoDashboardSummaryResponse}
     */
    apiWalletDashboardSummaryPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = WalletControllerDtoDashboardSummaryResponse;
      return this.apiClient.callApi(
        '/api/Wallet/Dashboard/Summary', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletDashboardUsageAndDestoryPost operation.
     * @callback module:api/WalletApi~apiWalletDashboardUsageAndDestoryPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WalletControllerDtoDashboardUsageAndDestoryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WalletControllerDtoDashboardUsageAndDestoryRequest} [walletControllerDtoDashboardUsageAndDestoryRequest] 
     * @param {module:api/WalletApi~apiWalletDashboardUsageAndDestoryPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WalletControllerDtoDashboardUsageAndDestoryResponse}
     */
    apiWalletDashboardUsageAndDestoryPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['walletControllerDtoDashboardUsageAndDestoryRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = WalletControllerDtoDashboardUsageAndDestoryResponse;
      return this.apiClient.callApi(
        '/api/Wallet/Dashboard/UsageAndDestory', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletDepositAddressPost operation.
     * @callback module:api/WalletApi~apiWalletDepositAddressPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WalletControllerDtoDepositAddressResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WalletControllerDtoDepositAddressRequest} [walletControllerDtoDepositAddressRequest] 
     * @param {module:api/WalletApi~apiWalletDepositAddressPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WalletControllerDtoDepositAddressResponse}
     */
    apiWalletDepositAddressPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['walletControllerDtoDepositAddressRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = WalletControllerDtoDepositAddressResponse;
      return this.apiClient.callApi(
        '/api/Wallet/DepositAddress', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletDepositPost operation.
     * @callback module:api/WalletApi~apiWalletDepositPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WalletControllerDtoDepositRequest} [walletControllerDtoDepositRequest] 
     * @param {module:api/WalletApi~apiWalletDepositPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiWalletDepositPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['walletControllerDtoDepositRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Wallet/Deposit', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletNotificationSettingInfoPost operation.
     * @callback module:api/WalletApi~apiWalletNotificationSettingInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WalletControllerDtoNotificationSettingInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/WalletApi~apiWalletNotificationSettingInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WalletControllerDtoNotificationSettingInfoResponse}
     */
    apiWalletNotificationSettingInfoPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = WalletControllerDtoNotificationSettingInfoResponse;
      return this.apiClient.callApi(
        '/api/Wallet/NotificationSettingInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletNotificationSettingUpdatePost operation.
     * @callback module:api/WalletApi~apiWalletNotificationSettingUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WalletControllerDtoNotificationSettingUpdateRequest} [walletControllerDtoNotificationSettingUpdateRequest] 
     * @param {module:api/WalletApi~apiWalletNotificationSettingUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiWalletNotificationSettingUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['walletControllerDtoNotificationSettingUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Wallet/NotificationSettingUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletToeknSendConditionsInfoPost operation.
     * @callback module:api/WalletApi~apiWalletToeknSendConditionsInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/WalletControllerDtoTokenSendConditionsInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/WalletApi~apiWalletToeknSendConditionsInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/WalletControllerDtoTokenSendConditionsInfoResponse}
     */
    apiWalletToeknSendConditionsInfoPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = WalletControllerDtoTokenSendConditionsInfoResponse;
      return this.apiClient.callApi(
        '/api/Wallet/ToeknSendConditionsInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletToeknSendConditionsUpdatePost operation.
     * @callback module:api/WalletApi~apiWalletToeknSendConditionsUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WalletControllerDtoTokenSendConditionsUpdateRequest} [walletControllerDtoTokenSendConditionsUpdateRequest] 
     * @param {module:api/WalletApi~apiWalletToeknSendConditionsUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiWalletToeknSendConditionsUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['walletControllerDtoTokenSendConditionsUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Wallet/ToeknSendConditionsUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiWalletXperTgePost operation.
     * @callback module:api/WalletApi~apiWalletXperTgePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/WalletControllerDtoXperTgeRequest} [walletControllerDtoXperTgeRequest] 
     * @param {module:api/WalletApi~apiWalletXperTgePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiWalletXperTgePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['walletControllerDtoXperTgeRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Wallet/XperTge', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
